module.exports = __webpack_public_path__ + "img/banner-sm-with-sign.67e8a9ba.png";